const isChildNodeOfHtmlElement = (element, parent) => {
    if (element && parent) {
        return parent.contains(element);
    }
    return false;
};
export const isChildNodeOfElement = (element, parent) => {
    return isChildNodeOfHtmlElement(element, document.getElementById(parent));
};
export const isChildNodeOfModal = (node) => {
    return !!node && isChildNodeOfModalRecursive(node);
};
const isChildNodeOfModalRecursive = (node) => {
    if (isModalNode(node)) {
        return true;
    }
    if (node.parentElement) {
        return isChildNodeOfModalRecursive(node.parentElement);
    }
    return false;
};
const isModalNode = (node) => {
    const modal = node.getAttribute('aria-modal');
    const role = node.getAttribute('role');
    return modal === 'true' && role === 'dialog';
};
//# sourceMappingURL=dom.js.map